export default __webpack_public_path__ + "static/media/thumbs-up.47ae7ab9.svg";